import React from "react";
import LegalLayout from "../components/LegalLayout";
import { openCookiePreferences } from "../components/CookieBanner";

export default function CookiePage() {
  return (
    <LegalLayout title="Cookie Policy" subtitle="Informativa cookie e tecnologie similari" lastUpdate="20 maggio 2026">
      <p>
        La presente Cookie Policy descrive l'utilizzo di cookie e tecnologie similari da parte del
        sito <strong>fantapartenope.it</strong>, gestito da <strong>ASD Fanta Partenope</strong> (di
        seguito "Titolare"). Il documento è redatto in conformità con il GDPR (Reg. UE 2016/679),
        l'art. 122 del D.Lgs. 196/2003 (Codice Privacy) e le Linee Guida del Garante per la
        Protezione dei Dati Personali del 10 giugno 2021.
      </p>

      <h2>1. Cosa sono i cookie</h2>
      <p>
        I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente,
        dove vengono memorizzati per essere ritrasmessi agli stessi siti nelle visite successive.
        Possono essere "di sessione" (cancellati alla chiusura del browser) o "persistenti"
        (memorizzati per un tempo determinato). Tecnologie analoghe (web beacon, pixel, local
        storage) sono equiparate ai cookie ai fini della presente Informativa.
      </p>

      <h2>2. Tipologie di cookie utilizzate da questo sito</h2>
      <p>
        Il Sito utilizza <strong>esclusivamente cookie tecnici di prima parte</strong>, esenti dal
        consenso preventivo ai sensi dell'art. 122 Codice Privacy. <strong>Non vengono utilizzati
        cookie di profilazione, advertising, marketing, remarketing o analytics di terze parti.</strong>
      </p>

      <h3>2.1 Cookie tecnici di prima parte (necessari)</h3>
      <div className="overflow-x-auto my-4">
        <table className="w-full text-sm border border-white/10 rounded-xl">
          <thead className="bg-fp-surface/60">
            <tr>
              <th className="text-left p-3 border-b border-white/10">Nome</th>
              <th className="text-left p-3 border-b border-white/10">Finalità</th>
              <th className="text-left p-3 border-b border-white/10">Durata</th>
              <th className="text-left p-3 border-b border-white/10">Tipo</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b border-white/5">
              <td className="p-3 font-mono text-xs">fp_admin_token</td>
              <td className="p-3">Mantenere autenticato l'amministratore nel pannello di gestione</td>
              <td className="p-3">7 giorni</td>
              <td className="p-3">localStorage</td>
            </tr>
            <tr className="border-b border-white/5">
              <td className="p-3 font-mono text-xs">fp_admin_user</td>
              <td className="p-3">Memorizzare il nome utente dell'amministratore loggato</td>
              <td className="p-3">7 giorni</td>
              <td className="p-3">localStorage</td>
            </tr>
            <tr>
              <td className="p-3 font-mono text-xs">fp_cookie_consent</td>
              <td className="p-3">Memorizzare la scelta dell'utente in merito ai cookie</td>
              <td className="p-3">12 mesi</td>
              <td className="p-3">localStorage</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h3>2.2 Servizi e cookie di terze parti</h3>
      <p>
        Il Sito può richiamare risorse o reindirizzare verso servizi gestiti da terze parti che
        operano in qualità di Titolari autonomi del trattamento dei dati raccolti tramite i propri
        cookie. Di seguito l'elenco completo:
      </p>

      <div className="overflow-x-auto my-4">
        <table className="w-full text-sm border border-white/10 rounded-xl">
          <thead className="bg-fp-surface/60">
            <tr>
              <th className="text-left p-3 border-b border-white/10">Servizio</th>
              <th className="text-left p-3 border-b border-white/10">Finalità</th>
              <th className="text-left p-3 border-b border-white/10">Informativa / Opt-out</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b border-white/5">
              <td className="p-3"><strong>Stripe</strong><br/>(Stripe Payments Europe Ltd., Irlanda)</td>
              <td className="p-3">Gestione del processo di pagamento. I cookie vengono installati solo quando l'utente accede alla pagina di checkout di Stripe.</td>
              <td className="p-3">
                <a href="https://stripe.com/it/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a><br/>
                <a href="https://stripe.com/it/cookies-policy/legal" target="_blank" rel="noopener noreferrer">Cookie Policy</a>
              </td>
            </tr>
            <tr className="border-b border-white/5">
              <td className="p-3"><strong>Emergent CDN</strong><br/>(Emergent Labs Inc., USA)</td>
              <td className="p-3">Erogazione di immagini statiche (logo, sfondi). Può raccogliere IP a fini di erogazione del contenuto.</td>
              <td className="p-3">
                Trasferimento extra-UE basato su SCC. Contatta il Titolare per maggiori informazioni.
              </td>
            </tr>
            <tr className="border-b border-white/5">
              <td className="p-3"><strong>Unsplash</strong><br/>(Unsplash Inc., Canada)</td>
              <td className="p-3">CDN per immagini predefinite di alcuni contenuti del Sito.</td>
              <td className="p-3">
                <a href="https://unsplash.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
              </td>
            </tr>
            <tr className="border-b border-white/5">
              <td className="p-3"><strong>Pexels</strong><br/>(Pexels GmbH, Germania)</td>
              <td className="p-3">CDN per immagini predefinite di alcuni contenuti del Sito.</td>
              <td className="p-3">
                <a href="https://www.pexels.com/it-it/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
              </td>
            </tr>
            <tr>
              <td className="p-3"><strong>WhatsApp / Meta</strong><br/>(Meta Platforms Ireland Ltd.)</td>
              <td className="p-3">Link al servizio WhatsApp (<code>wa.me</code>) per il contatto. Si attiva solo al click esplicito dell'utente.</td>
              <td className="p-3">
                <a href="https://www.whatsapp.com/legal/privacy-policy-eea" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <p>
        <strong>Nessuno di questi servizi installa cookie persistenti sul dispositivo dell'utente al
        momento del semplice caricamento delle pagine del Sito.</strong> L'eventuale interazione
        (es. avvio del checkout, click sul link WhatsApp) avviene su volontà esplicita dell'utente.
      </p>

      <h2>3. Cookie di profilazione, marketing, analytics, remarketing</h2>
      <p>
        <strong>Il Sito non utilizza alcuna tipologia di cookie o tecnologia di tracciamento di
        profilazione, marketing, analytics, advertising o remarketing</strong>, né strumenti come
        Google Analytics, Meta Pixel, Hotjar, Mixpanel, PostHog, TikTok Pixel, LinkedIn Insight o
        similari.
      </p>

      <h2>4. Come gestire e revocare il consenso</h2>
      <p>
        L'utente può in qualsiasi momento <strong>modificare le proprie preferenze sui cookie</strong> tramite il pulsante "Preferenze Cookie" presente nel footer di ogni pagina del Sito, oppure cliccando il pulsante qui sotto:
      </p>
      <p>
        <button
          onClick={openCookiePreferences}
          className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-fp-cyan text-fp-bg font-heading font-bold text-xs tracking-wider uppercase hover:shadow-[0_0_20px_rgba(0,229,255,0.5)] transition-all border-0 cursor-pointer"
          data-testid="cookie-reopen-banner"
        >
          🍪 Apri Preferenze Cookie
        </button>
      </p>

      <p>
        Inoltre, l'utente può gestire i cookie direttamente dalle impostazioni del proprio browser:
      </p>
      <ul>
        <li><a href="https://support.google.com/chrome/answer/95647?hl=it" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
        <li><a href="https://support.mozilla.org/it/kb/Attivare%20e%20disattivare%20i%20cookie" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
        <li><a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Safari (macOS)</a></li>
        <li><a href="https://support.apple.com/it-it/HT201265" target="_blank" rel="noopener noreferrer">Safari (iOS)</a></li>
        <li><a href="https://support.microsoft.com/it-it/microsoft-edge" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
        <li><a href="https://help.opera.com/en/latest/web-preferences/" target="_blank" rel="noopener noreferrer">Opera</a></li>
      </ul>
      <p>
        Si segnala che la disattivazione dei cookie tecnici può compromettere alcune funzionalità del
        Sito, in particolare l'accesso al pannello di amministrazione.
      </p>

      <h2>5. Registro dei consensi</h2>
      <p>
        Ai sensi del principio di accountability di cui all'art. 7 GDPR, il Titolare mantiene un
        registro dei consensi prestati dagli utenti tramite il cookie banner, conservando per
        ciascuno: scelta effettuata (accettazione / rifiuto), data e ora, indirizzo IP, user-agent
        del browser. Tali informazioni sono conservate per <strong>5 anni</strong> dalla revoca o
        dall'ultima manifestazione di consenso e sono utilizzate esclusivamente per finalità
        difensive in caso di contestazioni o accertamenti dell'Autorità Garante.
      </p>

      <h2>6. Diritti dell'interessato</h2>
      <p>
        Per l'esercizio dei diritti previsti dal GDPR (artt. 15-22), si rinvia alla{" "}
        <a href="/privacy" className="text-fp-cyan hover:underline">Privacy Policy</a> — sezione 8.
      </p>

      <h2>7. Modifiche alla Cookie Policy</h2>
      <p>
        La presente Cookie Policy può essere modificata per esigenze normative o organizzative. La
        versione vigente è sempre disponibile a questa pagina. Le modifiche sostanziali saranno
        evidenziate con un avviso nel banner.
      </p>

      <h2>8. Contatti</h2>
      <p>
        ASD Fanta Partenope — Via Vittorio Emanuele Terzo, 80013 Casalnuovo di Napoli (NA).
        <br />PEC: <a href="mailto:fantapartenope@pec.it">fantapartenope@pec.it</a>.
      </p>
    </LegalLayout>
  );
}
